<template>
  <div class="base-info">
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="140"
    >
      <FormItem label="发布学校" prop="schoolId">
        <ChooseSchoolForForm
          v-if="!detailInfo && portOrg != 2"
          v-model="selectSchoolData"
          @postSchoolRow="getSelectSchoolRow"
        ></ChooseSchoolForForm>
        <span v-else>{{ formValidate.schoolName }}</span>
      </FormItem>
      <FormItem label="指定校区" prop="branchId">
        <Select
          v-if="!detailInfo"
          v-model="formValidate.branchId"
          :disabled="classroomId ? true : false"
          class="class-form-item"
          @on-change="getBranchName"
        >
          <Option
            v-for="item in campusList"
            :key="item.branchId"
            :value="item.branchId"
          >{{ item.branchName }}</Option>
        </Select>
        <p v-else>{{ formValidate.branchName }}</p>
      </FormItem>
      <FormItem label="当前学期" prop="termId">
        <Select
          v-if="!detailInfo"
          v-model="formValidate.termId"
          class="class-form-item"
          :disabled="classroomId ? true : false"
          @on-change="getTermName"
        >
          <Option
            v-for="item in semesterList"
            :key="item.termId"
            :value="item.termId"
          >{{ item.yearName + item.termName }}</Option>
        </Select>
        <p v-else>{{ formValidate.termName }}</p>
      </FormItem>
      <FormItem label="套餐名称" prop="packageName">
        <Input
          v-model="formValidate.packageName"
          class="class-form-item"
          placeholder="请填写套餐名称"
        ></Input>
      </FormItem>
      <FormItem
        v-for="(item, comIndex) in formValidate.comboSelOptionList"
        :key="comIndex"
        :label="`套餐组合包${comIndex + 1}`"
        prop="productList"
      >
        <Row>
          <Input
            v-model="formValidate.comboSelOptionList[comIndex]['optionName']"
            placeholder="请输入套餐组合包的名称"
            class="class-form-item"
          ></Input>
          <Button
            v-show="comIndex == 0 && isActionCourse"
            style="margin-left: 16px"
            @click="handleAddCom(comIndex)"
          >添加组合包</Button>
          <Button
            v-show="comIndex > 0 && isActionCourse"
            type="warning"
            ghost
            style="margin-left: 16px"
            @click="handleDeleteCom(comIndex)"
          >删除组合包</Button>
        </Row>

        <p class="color-gray" style="margin: 4px 0">
          可输入上午、中午、下午时间段等方式，便于学生选课！
        </p>

        <div class="product-box" style="margin-bottom: 20px">
          <div class="flex justify-space_between" style="margin-bottom: 10px">
            <p>
              <strong>课程商品：</strong> 已选择课程商品（{{
                formValidate.comboSelOptionList[comIndex]['subProdInfoList']
                  .length
              }}）
            </p>
            <Button
              v-if="isActionCourse"
              type="primary"
              icon="md-add"
              @click="handleOpenCourse(comIndex)"
            >添加课程</Button>
          </div>
          <div class="table" style="margin-bottom: 16px">
            <Table
              :columns="selectComcolumns"
              :data="
                formValidate.comboSelOptionList[comIndex]['subProdInfoList']
              "
              border=""
            >
              <template slot="visibleType" slot-scope="{ row }">
                <span>{{ row.visibleType == 1 ? '可见' : '不可见' }}</span>
              </template>
              <template slot="timeDesc" slot-scope="{ row }">
                <TablePoptip :content="row.timeDesc" :show-poptips-content-length="30" :content-width="230"> </TablePoptip>
              </template>

              <template slot="studentTotal" slot-scope="{ row }">
                <span>{{
                  row.studentTotal == 0 ? '不限' : row.studentTotal
                }}</span>
              </template>

              <template slot="comboType" slot-scope="{ row, index }">
                <Checkbox
                  v-model="
                    formValidate.comboSelOptionList[comIndex][
                      'subProdInfoList'
                    ][index]['comboType']
                  "
                ></Checkbox>
              </template>

              <template slot="action" slot-scope="{ row, index }">
                <Button
                  v-if="isActionCourse"
                  type="error"
                  size="small"
                  @click="handleRemove(comIndex, index)"
                >删除</Button>
              </template>
            </Table>
          </div>
          <div style="margin-bottom: 10px" @click="handleClickCourse(comIndex)">
            素质课程最少购买：<InputNumber
              v-model="formValidate.comboSelOptionList[comIndex].courseMin"
              style="margin-right: 4px"
              :min="0"
              :max="999"
              @on-change="onChangeCourseMin"
              @on-focus="onFocusCourse(comIndex, 'courseMin')"
              @on-blur="onBlurCourse('courseMin')"
            ></InputNumber>门，素质课程最多购买：<InputNumber
              v-model="formValidate.comboSelOptionList[comIndex].courseMax"
              style="margin-right: 4px"
              :max="999"
              :min="0"
              @on-change="onChangeCourseMax"
              @on-blur="onBlurCourse('courseMax')"
            ></InputNumber>门，
          </div>
          <div @click="handleClickCourse(comIndex)">
            托管课程最少购买：<InputNumber
              v-model="formValidate.comboSelOptionList[comIndex].daycareMin"
              style="margin-right: 4px"
              :max="999"
              :min="0"
              @on-change="onChangeDaycareMin"
              @on-blur="onBlurCourse('daycareMin')"
            ></InputNumber>门，托管课程最多购买：<InputNumber
              v-model="formValidate.comboSelOptionList[comIndex].daycareMax"
              style="margin-right: 4px"
              :max="999"
              :min="0"
              @on-change="onChangeDaycareMax"
              @on-blur="onBlurCourse('daycareMax')"
            ></InputNumber>门
          </div>
          <p class="color-gray">
            指用户下单时，课程至少购买几门素质课程，最少0表示不限，最多购买999门。
          </p>
        </div>
      </FormItem>

      <!-- <FormItem label="套餐封面" prop="">
        <UploadBtn
          :text="`选择封面`"
          class="upload"
          :upload-type="1"
          :accept="`image/*`"
          @on-success="handleUploadImg"
        ></UploadBtn>
        <div v-if="imgFile.localUrl" class="cover-main">
          <Icon
            type="ios-close"
            size="30"
            class="delBtn"
            @click="handleDelCover"
          ></Icon>
          <img class="cover-img" :src="imgFile.localUrl" />
        </div>
        <p>
          建议尺寸750*560，小于5M的JPG、PNG格式图片，若不上传，则随机截取其中一个商品课程封面
        </p>
      </FormItem> -->

      <FormItem label="套餐内容" prop="">
        <Tag>{{ typeStr ? typeStr : '自动读取' }} </Tag>
        <p>选取所有的课程商品的课程类别</p>
      </FormItem>
      <FormItem label="价格描述" prop="classroomFee">
        <InputNumber
          v-model="formValidate.classroomFee"
          class="class-form-item"
          placeholder="请输入价格描述"
          :min="0"
          :formatter="(value) => `${parseFloat(Math.floor(value * 100) / 100)}`"
        ></InputNumber>
        <span>（元）</span>
        <p>仅用于在套餐课程列表展示价格，非实际下单金额</p>
      </FormItem>
      <FormItem label="报名范围" prop="">
        <div
          v-if="!formValidate.visibleDtoList.length"
          class="add-btn"
          @click="handleBookRange"
        >
          <div class="line"></div>
          <Icon type="md-add" size="20" color="#488ffa"></Icon>
          <span>圈定范围</span>
        </div>
        <span
          v-if="
            formValidate.visibleDtoList.length === 1 &&
              formValidate.visibleDtoList[0].gradeId === '0'
          "
          class="mb-1"
        >校区全部</span>
        <span
          v-if="formValidate.visibleDtoList.length"
          class="a-cursor ml-1 mb-1"
          @click="handleBookRange"
        >重新圈定</span>
        <div
          v-if="
            formValidate.visibleDtoList.length > 1 ||
              (formValidate.visibleDtoList.length == 1 &&
                formValidate.visibleDtoList[0].gradeId != '0')
          "
          class="w1000 mb-1"
        >
          <tr class="book-title">
            <td
              v-for="(book, index) in bookTableColumns"
              :key="'book' + index"
              class="book w200"
            >
              {{ book.title }}
            </td>
          </tr>
          <div
            v-for="(vis1, index) in formValidate.visibleDtoList"
            :key="'vis1' + index"
          >
            <div
              v-if="
                vis1.gradeId != '0' &&
                  formValidate.visibleDtoList.length > 0 &&
                  vis1.classId == '0'
              "
            >
              <tr>
                <td class="book w200">{{ vis1.gradeName }}</td>
                <td class="book w200">
                  {{ vis1.limitCount > 0 ? vis1.limitCount : '不限制' }}
                </td>
                <td class="book w200">/</td>
                <td class="book w200">/</td>
              </tr>
              <div
                v-for="(vis2, index2) in formValidate.visibleDtoList"
                :key="'vis2' + index2"
              >
                <tr
                  v-if="vis2.classId != '0' && vis2.gradeId == vis1.gradeId"
                  class="bg"
                >
                  <td class="book w200"></td>
                  <td class="book w200"></td>
                  <td class="book w200">
                    {{ vis2.className }}
                  </td>
                  <td class="book w200">
                    {{ vis2.limitCount > 0 ? vis2.limitCount : '不限制' }}
                  </td>
                </tr>
              </div>
            </div>
          </div>
        </div>

        <p>课程套餐仅报名范围内学生可报名，不设置则全校可报</p>
      </FormItem>
      <!-- <FormItem label="推荐报名年级" prop="">
        <div>
          <Select v-model="formValidate.gradeMin" style="width: 200px">
            <Option
              v-for="item in likeGradesList"
              :key="item.value"
              :value="item.value"
              >{{ item.label }}</Option
            >
          </Select>
          <span style="margin: 0 8px">~</span>
          <Select v-model="formValidate.gradeMax" style="width: 200px">
            <Option
              v-for="item in likeGradesList"
              :key="item.value"
              :value="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </div>
      </FormItem> -->
    </Form>
    <ChooseCourse
      ref="chooseCourseRef"
      :school-id="formValidate.schoolId"
      :term-id="formValidate.termId"
      :search-course-type="searchCourseType"
      @on-finish="onChooseCourseFinish"
    ></ChooseCourse>
    <ChooseBookRangeModal
      ref="chooseBookRangeModalRef"
      :school-id="formValidate.schoolId"
      @on-finish="onChooseBookRange"
    ></ChooseBookRangeModal>
  </div>
</template>

<script>
import { weekList, gradeList } from '@/utils/dictionary.js';
import schoolAdmin from '@/request/schoolAdmin/index.js';
import courseCenter from '@/request/courseCenter/index.js';
import ChooseCourse from './ChooseCourse';
import ChooseSchoolForForm from '@c/searchBlock/ChooseSchoolForForm';
import { selectComcolumns, courseFilterTypeKind } from '../assets/comboTable.js';
import UploadBtn from '@c/UploadBtn';
import { getGradeMinAndMax } from '@/utils/utils';
import { deepCopy } from '@/utils/utils.js';
import ChooseBookRangeModal from './ChooseBookRangeModal.vue';
import axios from 'axios';
export default {
  components: {
    ChooseCourse,
    UploadBtn,
    ChooseSchoolForForm,
    ChooseBookRangeModal
  },
  props: {
    detailInfo: {
      type: Object,
      default: () => null
    },
    productPackageId: {
      type: String,
      default: ''
    }

  },
  data() {
    const validateTermId = (rule, value, callback) => {
      if (!value && !this.detailInfo) {
        callback(new Error('请选择当前学期'));
      } else {
        callback();
      }
    };
    const validateProduct = (rule, value, callback) => {
      callback();
    };
    return {
      portOrg: Number(localStorage.getItem('portOrg')),
      bookTableColumns: [
        {
          title: '可报名年级'
        },
        {
          title: '年级人数限制'
        },
        {
          title: '可报名班级'
        },
        {
          title: '班级人数限制'
        }
      ],
      formValidate: {
        schoolId: '',
        schoolName: '',
        branchId: '',
        branchName: '',
        termName: '',
        termId: '',
        productList: [],
        visibleDtoList: [],
        comboSelOptionList: [{
          optionName: '',
          courseMin: 0,
          courseMax: 999,
          daycareMin: 0,
          daycareMax: 999,
          subProdInfoList: []
        }], // 套餐组合包
        subCourseList: [], // 素质课程
        subDaycareList: [], // 托管课程
        packageName: '',
        gradeMin: '',
        gradeMax: '',
        classroomFee: null,
        courseCover: null,
        selectComboSelIndex: -1
      },
      imgFile: {
        localUrl: '',
        file: '',
        type: 2 // 1: 后端返回，2:源文件
      },
      selectComcolumns,
      productList: [], // 已经选择的课程商品
      likeGradesList: gradeList, // 年级列表
      ruleValidate: {
        schoolId: [
          { required: true, message: '请选择发布学校', trigger: 'change' }
        ],
        termId: [
          // { required: true, message: '请选择当前学期', trigger: 'change' }
          { required: true, validator: validateTermId, trigger: 'change' }
        ],
        branchId: [
          { required: true, message: '请选择指定校区', trigger: 'change' }
        ],
        packageName: [
          { required: true, message: '请填写套餐名称', trigger: 'blur' }
        ],
        classroomFee: [
          {
            type: 'number',
            required: true,
            message: '请输入价格描述',
            trigger: 'blur'
          }
        ],
        productList: [
          {
            validator: validateProduct,
            required: true,
            trigger: 'change'
          }
        ]
      },
      classroomId: '',
      selectSchoolData: {},
      campusList: [],
      semesterList: [],
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      loadingSchool: false,
      searchCourseType: 0
    };
  },
  computed: {
    // 套餐内容
    typeStr() {
      const list = this.formValidate.comboSelOptionList.reduce((acc, cur, idx, src) => {
        acc.push(...cur.subProdInfoList);
        return acc;
      }, []);
      console.log('typeStrtypeStrtypeStr', list);
      const types = list ? list.map(item => {
        return item.courseTypeKind;
      }) : [];

      return courseFilterTypeKind(types);
    },
    isActionCourse() {
      return (
        (this.detailInfo && this.detailInfo.existOrder == 0) || !this.detailInfo
      );
    }
    // productNumber() {
    //   return this.formValidate.subDaycareList.length + this.formValidate.subCourseList.length
    // }
  },
  watch: {
    'formValidate.schoolId'(newVal) {
      this.$nextTick(() => {
        this.getBranchList();
        this.getTermlist();
      });
    },
    'formValidate.branchId'(newVal) {

    },
    detailInfo(newVal) {
      console.log(newVal);
      this.fillForm(newVal);
    }
  },
  created() {
    if (this.portOrg == 2) {
      this.formValidate.schoolId = this.userInfo.orgId;
      this.formValidate.schoolName = this.userInfo.orgName;
    }
  },
  methods: {
    async fillForm(info) {
      const {
        schoolId,
        schoolName,
        branchName,
        termName,

        courseCover,
        productPackageName,
        classroomFee,
        gradeMax,
        gradeMin,
        comboSelOptionList,
        termId,
        visibleDtoList
      } = info;

      comboSelOptionList && comboSelOptionList.forEach(item => {
        item.courseMax = item.courseMax ? item.courseMax : 999;
        item.courseMin = item.courseMin ? item.courseMin : 0;
        item.daycareMax = item.daycareMax ? item.daycareMax : 999;
        item.daycareMin = item.daycareMin ? item.daycareMin : 0;
        item.subProductList.forEach(item_1 => {
          item_1.sort = item_1.sortId;
          item_1.comboType = !!item_1.comboType;
        });
        item.subProdInfoList = item.subProductList;
      });
      comboSelOptionList ? this.formValidate.comboSelOptionList = comboSelOptionList : '';
      this.formValidate.schoolId = schoolId;
      this.formValidate.schoolName = schoolName;
      this.formValidate.branchName = branchName;
      this.formValidate.termName = termName;
      this.formValidate.termId = termId;
      this.formValidate.packageName = productPackageName;
      this.formValidate.classroomFee = Number(classroomFee) / 100;
      this.formValidate.courseCover = courseCover;
      this.formValidate = { ...this.formValidate, ...getGradeMinAndMax(gradeMin, gradeMax) };
      this.formValidate.visibleDtoList = visibleDtoList;
    },
    onChooseBookRange(res) {
      console.log(res);
      this.formValidate.visibleDtoList = res.data;
    },
    async handleCheckSubmit(name) {
      return new Promise(async(resolve, reject) => {
        this.$refs['formValidate'].validate(valid => {
          if (valid) {
            console.log(valid, this.checkFormMessage(), 123);
            this.checkFormMessage() ? resolve() : '';
          } else {
            if (!this.formValidate.schoolId) {
              this.$Message.warning('请选择发布学校');
              return null;
            }
            if (!this.formValidate.branchId) {
              this.$Message.warning('请选择指定校区');
              return null;
            }
            if (!this.formValidate.termId) {
              this.$Message.warning('请选择当前学期');
              return null;
            }
            if (!this.formValidate.packageName) {
              this.$Message.warning('请输入套餐名称');
              return null;
            }
            if (!this.formValidate.classroomFee) {
              this.$Message.warning('请输入价格描述');
              return null;
            }
          }
        });
      });
    },
    checkFormMessage() {
      let status = true;
      const comboSelOptionList = this.formValidate.comboSelOptionList;
      for (let i = 0, len = comboSelOptionList.length; i < len; i++) {
        if (!comboSelOptionList[i]['optionName']) {
          this.$Message.warning(`请输入套餐组合包${i + 1}的名称`);
          status = false;
          break;
        }
        if (comboSelOptionList[i]['subProdInfoList'].length == 0) {
          this.$Message.warning(`请选择套餐组合包${i + 1}的课程商品`);
          status = false;
          break;
        }
        if (comboSelOptionList[i]['courseMax'] < comboSelOptionList[i]['courseMin']) {
          this.$Message.warning(`套餐组合包${i + 1}：素质课程最多购买门数不得低于最少购买门数`);
          status = false;
          break;
        }
        if (comboSelOptionList[i]['daycareMax'] < comboSelOptionList[i]['daycareMin']) {
          this.$Message.warning(`套餐组合包${i + 1}：托管课程最多购买门数不得低于最少购买门数`);
          status = false;
          break;
        }
      }

      return status;
    },
    async getParameter() {
      return new Promise(async(resolve, reject) => {
        const {
          schoolId,
          schoolName,
          branchId,
          termId,
          packageName,
          classroomFee,
          gradeMin,
          gradeMax,
          courseCover,
          visibleDtoList
        } = this.formValidate;
        const comboSelOptionList = deepCopy(this.formValidate.comboSelOptionList);
        comboSelOptionList.forEach(item => {
          const subProdInfoList = [];
          item.subProdInfoList.forEach(item_1 => {
            subProdInfoList.push({
              prodId: item_1.productId,
              sortId: item_1.sort,
              comboType: item_1.comboType ? 1 : 0
            });
          });
          delete item.subProductList;
          item.subProdInfoList = subProdInfoList;
        });
        const isLimitEnroll = visibleDtoList.length > 0 ? 1 : 0;
        const dTOList = [];
        if (isLimitEnroll == 1) {
          visibleDtoList.forEach(item => {
            dTOList.push({
              orgId: schoolId,
              orgName: schoolName,
              classroomId: this.productPackageId ? this.productPackageId : '',
              branchId: item.branchId,
              branchName: item.branchName,
              gradeName: item.gradeName,
              gradeId: item.gradeId,
              classId: item.classId,
              limitCount: item.limitCount
            });
          });
        }

        resolve({
          schoolId,
          branchId,
          termId,
          packageName,
          classroomFee: classroomFee * 100,
          gradeMin,
          gradeMax,
          courseCover,
          comboSelOptionList,
          isLimitEnroll,
          visibleDtoList: dTOList
        });
        //  let courseCover = '727536934649331713'
      });
    },
    // 选择课程
    handleOpenCourse(index) {
      if (!this.formValidate.schoolName) {
        return this.$Message.error('请先选择学校！');
      }
      if (!this.formValidate.termId) {
        return this.$Message.error('请先选择学期！');
      }

      this.$nextTick(() => {
        this.selectComboSelIndex = index;
        const productList = deepCopy(this.formValidate.comboSelOptionList[index]['subProdInfoList']);
        this.$refs.chooseCourseRef.open(productList);
      });
    },
    // 点击选择固定范围
    handleBookRange() {
      if (!this.formValidate.branchId) {
        this.$Message.warning('请先选择学校校区');
      } else {
        const data = {
          list: this.formValidate.visibleDtoList.map(item => { return { id: item.gradeId, ...item }; })
        };
        this.$refs.chooseBookRangeModalRef.open(data);
        //  this.bookRangeModalShow = !this.bookRangeModalShow;
      }
    },
    // 打开弹窗
    openModal(name, id) {
      this.$refs[name].open(id);
    },
    //
    onChooseCourseFinish(data) {
      data.comboType = !!data.comboType;
      this.formValidate.comboSelOptionList[this.selectComboSelIndex]['subProdInfoList'] = data.sort((a, b) => { return a.sort - b.sort; });
      this.formValidate = Object.assign({}, this.formValidate);
      //  this.$refs.formValidate.validateField('productList');
    },
    getSelectSchoolRow(row) {
      this.formValidate.schoolId = row.orgId;
      this.formValidate.schoolName = row.name;
      this.selectSchoolData = row;
      this.$refs.formValidate.validateField('schoolId');
    },
    /** === 有关选择校区start ===**/
    // 查询校区列表
    async getBranchList() {
      const res = await schoolAdmin.getBranchList({
        orgId: this.formValidate.schoolId
      });
      if (res.status === 200) {
        this.campusList = res.message;
        if (this.formValidate.branchId === '') {
          this.formValidate.branchId = this.campusList[0].branchId;
          this.formValidate.branchName = this.campusList[0].branchName;
        }
      }
    },
    getBranchName(id) {
      const obj = this.campusList.find(item => {
        return item.branchId === id;
      });
      if (obj) {
        console.log('是啥----', obj);
        this.formValidate.branchName = obj.branchName;
      }
    },
    /** === 有关选择校区end ===**/
    /** === 有关选择学期start ===**/
    async getTermlist() {
      const params = {
        orgId: this.formValidate.schoolId,
        termState: 1
      };
      const res = await courseCenter.getListTerms(params);
      if (res.status === 200) {
        this.semesterList = res.message;
      }
    },
    getTermName(id) {
      const obj = this.semesterList.find(item => {
        return item.termId === id;
      });
      if (obj) {
        this.formValidate.termName = obj.termName;
      }
      this.formValidate.comboSelOptionList.forEach(item => {
        item.subProdInfoList = [];
      });
      // this.formValidate.subCourseList = []
      // this.formValidate.subDaycareList = []
    },
    /** === 有关选择学期end ===**/
    handleRemove(comIndex, index) {
      // if (this.formValidate[`productList` + type].length < 3) {
      //   this.$Message.error('至少选择2门课程商品');
      //   return null;
      // }
      this.formValidate.comboSelOptionList[comIndex]['subProdInfoList'].splice(index, 1);
    },
    // 删除组合包
    handleDeleteCom(index) {
      this.$Modal.confirm({
        title: '温馨提示',
        content: '<p>是否确认删除？</p>',
        onOk: () => {
          this.formValidate.comboSelOptionList.splice(index, 1);
        },
        onCancel: () => {

        }
      });
    },
    // 添加组合包
    handleAddCom() {
      if (this.formValidate.comboSelOptionList.length >= 3) {
        this.$Message.warning('最多支持添加3个组合包');
        return null;
      }
      this.formValidate.comboSelOptionList.push({
        optionName: '',
        courseMin: 0,
        courseMax: 999,
        daycareMin: 0,
        daycareMax: 999,
        subProdInfoList: []
      });
    },
    handleDelCover() {
      this.imgFile.localUrl = '';
      this.imgFile.file = '';
    },
    onChangeCourseMin(val) {
      this.$nextTick(() => {
        this.changeComboSelOption(val, 'courseMin');
      });
    },
    onChangeCourseMax(val) {
      this.$nextTick(() => {
        this.changeComboSelOption(val, 'courseMax');
      });
    },
    onChangeDaycareMin(val) {
      this.$nextTick(() => {
        this.changeComboSelOption(val, 'daycareMin');
      });
    },
    onChangeDaycareMax(val) {
      this.$nextTick(() => {
        this.changeComboSelOption(val, 'daycareMax');
      });
    },
    changeComboSelOption(val, type) {
      this.formValidate.comboSelOptionList[this.selectComboSelIndex][type] = Math.trunc(val);
      // if (!val) {
      //   this.formValidate.comboSelOptionList[this.selectComboSelIndex][type] = -1
      // } else if (val < 0 && val != -1) {
      //   this.formValidate.comboSelOptionList[this.selectComboSelIndex][type] = -1
      // } else {
      //   this.formValidate.comboSelOptionList[this.selectComboSelIndex][type] = Math.trunc(val)
      // }
    },
    onBlurCourse(type) {
      // if (this.formValidate.comboSelOptionList[this.selectComboSelIndex][type] == 1) {
      //   this.formValidate.comboSelOptionList[this.selectComboSelIndex][type] = 2
      // }
    },
    onFocusCourse(index, type) {

    },
    handleClickCourse(index, type) {
      this.selectComboSelIndex = index;
    }
  }
};
</script>
<style lang="scss" scoped>
.search-line {
  margin-bottom: 16px;
  display: flex;
  .search-input {
    width: 160px;
    margin-right: 16px;
  }
  .search-select {
    width: 250px;
    margin-right: 16px;
  }
}
.product-box {
  padding: 16px;
  border: 1px solid #eee;
  border-radius: 6px;
}
.add-btn {
  width: 95px;
  height: 30px;
  border: 1px dashed transparent;
  background: linear-gradient(white, white) padding-box,
    repeating-linear-gradient(
      -45deg,
      #488ffa 0,
      #488ffa 0.5em,
      white 0,
      white 0.75em
    );
  color: #488ffa;
  border-radius: 4px;
  text-align: center;
  line-height: 30px;

  .icon {
    margin-right: 2px;
  }
}
.cover-main {
  width: 168px;
  height: 168px;
  padding: 8px;
  position: relative;
  .delBtn {
    width: 32px;
    height: 32px;
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
    color: #fff;
  }
  img {
    width: 100%;
    height: 100%;
  }
}

.book-title {
  background-color: rgb(247, 248, 250);
  font-weight: 700;

  tr {
    border: 1px solid rgb(247, 248, 250);
  }
}

.book {
  line-height: 50px;
  text-indent: 10px;
}

.w100 {
  width: 100px;
}

.w200 {
  width: 200px;
}

.w1000 {
  width: 800px;
}

.bg {
  background-color: rgb(247, 248, 250);
}
.a-cursor {
  color: #488ffa;
  cursor: pointer;
}
.ml-1 {
  margin-left: 4px;
}
.mb-1 {
  margin-bottom: 4px;
}
</style>
